import { Modal } from 'react-bootstrap';

export default function CancelarVentaModal({ show, onCancel, onConfirm, venta }) {
    const folio = venta?.folio || '';

    return (
        <Modal show={!!show} onHide={onCancel} centered>
            <Modal.Header closeButton>
                <Modal.Title>Cancelar venta</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="alert alert-danger">
                    Esta acción es irreversible y tiene impacto directo en el inventario.
                </div>

                <div className="mb-3">
                    <strong>Folio:</strong> {folio || '-'}
                </div>

                <div className="d-flex justify-content-end gap-2">
                    <button type="button" className="btn btn-secondary" onClick={onCancel}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-danger" onClick={onConfirm}>
                        Confirmar
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
}